
import { Component, Vue } from "vue-property-decorator";
import { Route, RawLocation } from "vue-router";
import { API_ROUTES } from "@/utils/API";
import { API_TCandidate } from "@/models/company_candidates";
import { convertBadgeType } from "@/models/candidate";

import { CANDIDATE_ASSESSMENT_SERVICE, START_SERVICE_EVENT } from "@/constants/services";
import Page from "@/layouts/Page.vue";
import AppProfile from "@/components/V2/AppProfile/AppProfile.vue";
import StartSWBanner from "@/components/V2/StartSWBanner/StartSWBanner.vue";
import NewWidgetSkilledWorkerVisa from "@/components/V2/WidgetSkilledWorkerVisa/NewWidgetSkilledWorkerVisa.vue";

const INVITE_CANDIDATE_ROUTE = "InviteCandidate";

const VALUE_NAME = "name";
const VALUE_JOB_POSITION = "job_position";
const VALUE_ASS_RESULT = "ass_result";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    NewWidgetSkilledWorkerVisa,
    StartSWBanner,
    Page,
    AppProfile,
    Loader: () => import("@/components/Loader/Loader.vue"),
    IconButtonBlock: () =>
      import("@/modules/Compliance/Blocks/IconButtonBlock/IconButtonBlock.vue"),
    PopupSkilledWorkerVisaService: () =>
      import("@/modules/Compliance/Popups/PopupSkilledWorkerVisaService.vue"),
    SubmitRequestVisaPopUp: () => import("@/components/Popups/SubmitRequestVisaPopUp.vue"),
  },
})
export default class EmployerServicesCandidates extends Vue {
  loading = false;

  candidates: API_TCandidate[] = [];

  selectedCandidate = {
    id: 0,
    isOutside: false,
  };

  showSkilledWorkerPopup = false;

  openSkilledWorkerPopup() {
    // TO DO: refactor
    this.$root.$emit("open-start-sw-popup");
    // this.showSkilledWorkerPopup = false;

    // this.$nextTick(() => {
    //   this.showSkilledWorkerPopup = true;
    // });
  }

  closeSkilledWorkerPopup() {
    this.showSkilledWorkerPopup = false;

    this.openSubmitRequestVisaPopup();
  }

  submitRequestVisaPopup = false;

  openSubmitRequestVisaPopup(): void {
    this.submitRequestVisaPopup = true;
  }

  closeSubmitRequestVisaPopup(): void {
    this.submitRequestVisaPopup = false;
  }

  async inviteCandidate() {
    const query = {
      event: START_SERVICE_EVENT,
      service: CANDIDATE_ASSESSMENT_SERVICE,
    };

    await this.$router.push({
      name: INVITE_CANDIDATE_ROUTE,
      query,
    });
  }

  getBadgeType(badgeType: string) {
    return convertBadgeType(badgeType, false);
  }

  selectCandidate(payload) {
    const { case_id, is_outside } = payload;

    this.selectedCandidate = {
      id: case_id,
      isOutside: is_outside,
    };

    this.openSkilledWorkerPopup();
  }

  async fetchCandidates(): Promise<void> {
    try {
      this.loading = true;

      const { data } = await this.axios.get<API_TCandidate[]>(API_ROUTES.COMPANY_CANDIDATES);

      if (!data) return;

      this.candidates = data;
    } finally {
      this.loading = false;
    }
  }

  beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: RawLocation | ((vm: Vue) => void)) => void
  ): void {
    next((vm: any) => {
      vm.fetchCandidates();
    });
  }

  headers = [
    {
      label: this.$t("table.headers.name"),
      value: VALUE_NAME,
      filter: true,
    },
    {
      label: this.$t("table.headers.jobPosition"),
      value: VALUE_JOB_POSITION,
      filter: true,
    },
    {
      label: this.$t("table.headers.eligibilityCheckResult"),
      value: VALUE_ASS_RESULT,
      filter: true,
    },
    {
      label: "Action",
      value: "actions",
      span: 0.5,
    },
  ];
}
